<template>
    <v-row class="align-center justify-space-between mb-2 px-0 px-md-8" :class="{ 'mt-15': !md, 'mt-10 pt-10': md }">
        <!-------------- title ----------------->
        <v-col :cols="centered || !$slots.actions ? 12 : 6" :md="centered ? 12 : 3" class="py-md-3 py-0" :class="centered ? 'text-center' : 'text-md-left'">
            <h1 class="text-subtitle-1 text-md-h4 text-truncate">{{ title }}</h1>
        </v-col>

        <!-------------- azioni (su desktop vanno in fondo alla riga) ----------------->
        <v-col
            v-if="$slots.actions"
            :cols="centered ? 12 : 6"
            :md="centered ? 12 : 4"
            class="d-flex align-center flex-wrap py-1 order-md-last"
            :class="centered ? 'justify-center' : 'justify-center justify-md-end'"
            style="gap: 8px"
        >
            <slot name="actions" />
        </v-col>

        <!-------------- azioni secondarie: riga propria ----------------->
        <v-col v-if="$slots.actions2" cols="12" class="d-flex justify-center justify-md-end align-center flex-wrap py-1 order-md-last" style="gap: 8px">
            <slot name="actions2" />
        </v-col>

        <!-------------- search ----------------->
        <v-col v-if="$slots.default" cols="12" md="5" class="d-flex justify-center py-0 py-md-3">
            <slot />
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: 'cpPageTitle',
    props: {
        title: { type: String, required: true },
        // ponytail: unica variante che serve oggi (Admin): titolo e azioni centrati, senza ricerca
        centered: { type: Boolean, default: false }
    },
    computed: {
        md() {
            return this.$vuetify.breakpoint.mdAndUp
        }
    }
}
</script>
